export default __webpack_public_path__ + "static/media/studies_img_one.faed3a5e.jpg";